import styled from 'styled-components';
import { DropdownWrapper } from './DropdownWrapper';

export const StyledCoreDropdown = styled(DropdownWrapper)`
  &[data-readonly='true'] {
    overflow-x: hidden;

    ::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
    -ms-overflow-style: none; /* Edge */
    scrollbar-width: none; /* Firefox */
  }

  .text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  &&&& {
    [data-role='queryBuilder'][data-view-mode='true'] & {
      display: none !important;
    }
  }
`;

export const ReadOnlyLabel = styled.div`
  [data-role='queryBuilder']:not([data-view-mode='true']) & {
    display: none !important;
  }
`;
